var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFall2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192.3 75.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f60;}.cls-2{fill:#b2b2b2;}.cls-3{fill:#575656;}.cls-4{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 192.3,
    height: 75.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.15,30.37h-1v2.3h-.7c-.7,0-1.2-.1-1.5-.2-.3-.2-.4-.4-.4-.8v-1.4h-1l-.1,1.6c0,.8,.2,1.3,.6,1.6,.4,.3,1.2,.5,2.3,.5h.7v1h1v-1h6.8v-1.2h-6.7v-2.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.75 14.17 90.35 14.17 90.35 6.97 89.05 6.97 89.05 15.37 93.75 15.37 93.75 14.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.85,
    y: 17.27,
    width: 153,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.05,
    y: 15.77,
    width: 5.2,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.15,
    y: 14.37,
    width: 1,
    height: 28.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 159.95,
    y: 15.77,
    width: 5.2,
    height: 3.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 167.05,
    y: 14.37,
    width: 1,
    height: 28.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "100.05 38.27 100.05 34.27 104.15 34.27 104.15 32.67 100.05 32.67 100.05 29.07 104.95 29.07 104.95 27.57 98.35 27.57 98.35 38.27 100.05 38.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "92.05 39.07 92.05 27.47 90.35 27.47 90.35 39.07 87.05 38.27 91.25 48.77 95.45 38.27 92.05 39.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "165.85 53.27 165.55 54.27 90.75 54.27 90.75 53.27 165.85 53.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "192.15 53.27 192.15 54.27 169.55 54.27 169.25 53.27 192.15 53.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177.35,
    y: 45.77,
    width: 14.8,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.45,46.87c-2.3,.3-4.5,.6-6.8,1h-.2c-1.4,.2-2.8,.4-4.3,.6-11.8,1.8-24.7,3.8-45.4,4.7-7.8,.4-16.6,.6-27,.6h0c-37.8,0-56.2-2.8-72.4-5.3-3.8-.6-7.5-1.1-11.3-1.7l.5-4c3.9,.5,7.5,1.1,11.4,1.7,16.1,2.5,34.3,5.3,71.8,5.3h0c37.5,0,55.7-2.8,71.8-5.3,3.9-.6,7.5-1.1,11.4-1.7l.5,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.55,47.47l-.1,.4h.2l-.1-.4ZM17.05,57.87l-2.9-10-.1-.4-.1,.4-2.9,10H.85v11.8H27.15v-11.8h-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.65,57.87v11.8h-26.3v-11.8h10.1l1-3.6,.3-1,1.6-5.4h.2l1.6,5.4,.3,1,1,3.6h10.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 187.25,
    y: 22.37,
    width: 1,
    height: 43.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 185.85,
    y: 57.37,
    width: 3.7,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 185.85,
    y: 38.27,
    width: 3.7,
    height: 5.2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall2);
export default __webpack_public_path__ + "static/media/Fall2.bf34860253fb08752ba807ff99f14383.svg";
export { ForwardRef as ReactComponent };